var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-container",
    {
      attrs: {
        title: _vm.$t(_vm.lblSetting.blockTitle),
        loading: false,
        "search-visible": _vm.searchVisible,
        "hide-edit-button": true,
        "hide-add-button": _vm.hideAddButton,
        "add-button-tool-tip": _vm.AddButtonToolTip
      },
      on: { add: _vm.handleOpenModal },
      model: {
        value: _vm.coKeyword,
        callback: function($$v) {
          _vm.coKeyword = $$v
        },
        expression: "coKeyword"
      }
    },
    [
      _c(
        "template",
        { slot: "sub-nav" },
        [_c("router-view", { attrs: { name: "subnav" } })],
        1
      ),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c(
        "base-modal-duplicate",
        {
          key: "1",
          ref: "create-block-modal",
          attrs: {
            "show-create-another": false,
            loading: _vm.dtIsRecording,
            "action-position": "center",
            icon: "immeuble_icon",
            "hide-default-action": true,
            title: _vm.blockModalTitle,
            "max-width": _vm.blockMaxWidth,
            "before-close": _vm.handleBeforeModalClose,
            "submit-btn-title": _vm.buttonText
          },
          on: { onRecord: _vm.handleSaveBlock, onClose: _vm.handleClose },
          model: {
            value: _vm.dtBlockModalVisible,
            callback: function($$v) {
              _vm.dtBlockModalVisible = $$v
            },
            expression: "dtBlockModalVisible"
          }
        },
        [
          _c("block-modal-vertical"),
          _vm._v(" "),
          !_vm.isUpdateAction
            ? _c(
                "template",
                { slot: "action-between" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "#2E038C",
                        flat: "",
                        loading: _vm.dtIsRecordingCreateApartment
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.handleSaveAndCreateAppartments($event)
                        }
                      }
                    },
                    [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(_vm.lblSetting.btnSaveAndCreateAppartments)
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "base-modal-duplicate",
        {
          key: "2",
          attrs: {
            loading: _vm.dtIsRecording,
            "create-another": _vm.dtApartmentCreateAnother,
            "show-create-another": !_vm.isUpdateAction,
            "action-position": "center",
            icon: "apt_icon",
            "max-width": _vm.apartmentMaxWidth,
            "hide-default-action": true,
            title: _vm.apartmentModalTitle,
            "before-close": _vm.handleBeforeModalClose,
            "submit-btn-title": _vm.buttonText
          },
          on: {
            "update:createAnother": function($event) {
              _vm.dtApartmentCreateAnother = $event
            },
            onRecord: _vm.handleSaveApartment,
            onClose: _vm.handleClose
          },
          model: {
            value: _vm.dtApartmentModalVisible,
            callback: function($$v) {
              _vm.dtApartmentModalVisible = $$v
            },
            expression: "dtApartmentModalVisible"
          }
        },
        [
          _c("apartment-modal-vertical", {
            attrs: {
              "block-id": _vm.dtBlockId,
              "creation-success": _vm.dtSuccess
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "base-modal-duplicate",
        {
          key: "3",
          attrs: {
            "show-create-another": false,
            loading: _vm.dtIsRecording,
            "action-position": "center",
            icon: "person_add",
            "icon-type": "icon",
            "before-close": _vm.handleBeforeModalClose,
            "submit-btn-title": _vm.memberButtonText,
            "hide-default-action": true,
            title: _vm.memberModalTitle,
            "is-dark-title": "",
            "max-width": _vm.memberMaxWidth
          },
          on: { onRecord: _vm.handleSaveMember, onClose: _vm.handleClose },
          model: {
            value: _vm.dtProfileModalVisible,
            callback: function($$v) {
              _vm.dtProfileModalVisible = $$v
            },
            expression: "dtProfileModalVisible"
          }
        },
        [_c("profile-modal-vertical", { ref: "profile-modal" })],
        1
      ),
      _vm._v(" "),
      _vm.dtEquipmentModalVisible
        ? _c(
            "base-modal-duplicate",
            {
              key: "4",
              ref: "create-update-equipment-modal",
              attrs: {
                "show-create-another": false,
                loading: _vm.dtIsRecording,
                "action-position": "center",
                icon: _vm.equipmentIcon,
                "icon-type": "icon",
                "before-close": _vm.handleBeforeModalClose,
                "submit-btn-title": _vm.buttonText,
                "hide-default-action": true,
                title: _vm.equipmentModalTitle,
                "is-dark-title": "",
                "max-width": _vm.apartmentMaxWidth
              },
              on: {
                onRecord: _vm.handleSaveEquipment,
                onClose: _vm.handleClose
              },
              model: {
                value: _vm.dtEquipmentModalVisible,
                callback: function($$v) {
                  _vm.dtEquipmentModalVisible = $$v
                },
                expression: "dtEquipmentModalVisible"
              }
            },
            [
              _c("equipment-modal-vertical", {
                ref: "equipment-modal",
                attrs: { isVehicle: _vm.isVehicle }
              }),
              _vm._v(" "),
              _vm.isUpdateAction
                ? _c(
                    "template",
                    { slot: "action-between" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "#2E038C",
                            flat: "",
                            loading: _vm.dtIsRecording
                          },
                          nativeOn: {
                            click: function($event) {
                              _vm.handleSaveEquipment(true)
                            }
                          }
                        },
                        [
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.currentEquipment.disable
                                  ? _vm.$t(_vm.lblSetting.btnEnable)
                                  : _vm.$t(_vm.lblSetting.btnDisable)
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dtMaintenanceModalVisible
        ? _c(
            "base-modal-duplicate",
            {
              key: "5",
              ref: "create-update-maintenance-modal",
              attrs: {
                "show-create-another": false,
                loading: _vm.dtIsRecording,
                "action-position": "center",
                icon: "handyman",
                "icon-type": "icon",
                "before-close": _vm.handleBeforeModalClose,
                "submit-btn-title": _vm.buttonText,
                "hide-default-action": true,
                title: _vm.maintenanceModalTitle,
                "is-dark-title": "",
                "max-width": _vm.maintenanceMaxWidth
              },
              on: {
                onRecord: _vm.handleSaveMaintenance,
                onClose: _vm.handleClose
              },
              model: {
                value: _vm.dtMaintenanceModalVisible,
                callback: function($$v) {
                  _vm.dtMaintenanceModalVisible = $$v
                },
                expression: "dtMaintenanceModalVisible"
              }
            },
            [
              _c("maintenance-modal-vertical", {
                ref: "maintenance-modal",
                attrs: {
                  isScheludeEquipmentMaintenance:
                    _vm.isScheludeEquipmentMaintenance,
                  isUpdateMaintenance: _vm.isUpdateMaintenance,
                  maintenanceData: _vm.maintenanceData
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dtErrorModalVisible
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleRemoveError }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ad4064b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ad4064b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/template.html
// module id = null
// module chunks = 